export default __webpack_public_path__ + "static/media/M_sound.7a6018b2.mp3";